import type { LegalBlock, LegalDocument } from "./content/types";

/** `2026-10-12` → "12 de outubro de 2026". Em UTC: a data é do documento, não do fuso de quem lê. */
export const formatLegalDate = (iso: string) =>
  new Intl.DateTimeFormat("pt-BR", {
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: "UTC",
  }).format(new Date(`${iso}T00:00:00Z`));

const blockText = (block: LegalBlock): string => {
  switch (block.type) {
    case "paragraph":
    case "subheading":
      return block.text;
    case "list":
      return block.items.join(" ");
    case "table":
      return block.rows.flatMap(row => Object.values(row)).join(" ");
    case "timeline":
      return block.items.map(item => `${item.time} ${item.text}`).join(" ");
    case "faq":
      return block.items
        .map(item => `${item.question} ${item.answer}`)
        .join(" ");
    case "callout":
      return `${block.title} ${block.text}`;
    case "action":
      return block.label;
  }
};

/** Minutos de leitura a 200 palavras por minuto — o ritmo de texto técnico em português. */
export const readingMinutes = (document: LegalDocument) => {
  const text = document.sections
    .flatMap(section => [
      section.title,
      section.summary,
      ...section.blocks.map(blockText),
    ])
    .join(" ");
  const words = text.split(/\s+/).filter(Boolean).length;
  return Math.max(1, Math.round(words / 200));
};

/** Texto corrido sem a marcação (`**negrito**`, `[rótulo](link)`), para JSON-LD. */
export const plainText = (text: string) =>
  text.replace(/\*\*(.+?)\*\*/g, "$1").replace(/\[([^\]]+)\]\([^)]+\)/g, "$1");
